import {Agent} from "@atproto/api";
import {useMemo} from "react";
import {useAuth} from "@/app/auth";

export function useATProtoAgent() {
  const [{session}] = useAuth();

  return useMemo(() => {
    if (!session) {
      throw new Error("ATProtoAgent requires an authenticated agent");
    }
    return new Agent(session);
  }, [session]);
}
